<div id="resetPassword-component" class="h-100 bg-image" style="background-image: url('assets/img/default-login.jpg')">
    <div class="g-0 overlay">
        <div class="screen-card">
            <div class="logo">
                <img src="assets/img/c8b00319-2bb7-4001-9316-580b17ffc717_480.png" />
            </div>
           <input name="passwordResetView" type="hidden" [ngModel]="currentView" />
            <div class="input-heading">Let’s reset your password!</div>
            <div *ngIf="currentView == 'username'">
                <div class="form-group">
                    <mat-form-field appearance="outline" class="example-full-width mask">
                        <mat-label>Username</mat-label>
                        <input name="username" autocomplete="off" value="" type="text" matInput />
                    </mat-form-field>
                </div>
                <div class="input-bottom" (click)="showEmail()">
                    <a>Use your email instead?</a>
                </div>
            </div>
            <div *ngIf="currentView == 'email'">
                <div class="form-group">
                    <mat-form-field appearance="outline" class="example-full-width mask">
                        <mat-label>Email</mat-label>
                        <input autocomplete="off" name="email" value="" type="text" matInput />
                    </mat-form-field>
                </div>
                <div class="input-bottom" (click)="showUsername()">
                    <a>Use your username instead?</a>
                </div>
            </div>
            <div class="btns-section">
                <div class="anchor"><a href="/">Back to login</a></div>
                <div class="login-btn">
                    <button class="btn btn-primary">Reset password</button>
                </div>
            </div>
            
            <div *ngIf="message" [class]="'alert alert-' +message.type" role="alert" style="margin-top:50px">
                {{message.text}}
            </div>
        </div>

        <div class="term-of-services">
            <div class="policy-text">
                By clicking on “Login”, you are agreeing to our
                <a href="/Terms.aspx">Terms of service</a> and <br />
                acknowledge that our Privacy policy applies to you
            </div>
            <div class="version-text">
                © 2023 m-View Live Video Pty Ltd | Altitude version: {{version}}
            </div>
        </div>
    </div>
</div>
